// translations/pages/team/fr.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageFR = {
  hero: {
    title: 'Équipe',
    intro: 'Adrian Eisenmeier et Nikolai Genov ont fondé pAIoneer Labs GmbH et la dirigent en tant que gérants.',
    members: 'Adrian Eisenmeier est physicien diplômé et conçoit des systèmes là où l’IA, l’architecture logicielle, la protection des données et la sécurité se rejoignent. Nikolai Genov est docteur en bio-informatique et responsable technique pour le développement logiciel assisté par l’IA et l’analyse de données dans les environnements réglementés de la santé, des sciences de la vie et de la finance. Alina Tselinina est développeuse logiciel et ingénieure de données, titulaire d’un master en mathématiques financières et actuarielles, et développe des applications, des API REST et des pipelines de données en Python et en R.'
  },
  card: {
    cta: 'Voir le profil'
  },
  profile: {
    overview: 'Équipe',
    membersLabel: 'Membres de l’équipe'
  }
};
